import React from "react";
import { FormattedMessage } from "react-intl";
import CustomChip from "../../../../general/chips";
import "./style.css";

const TypesFilters = ({ filterList, activeFilter, setActiveFilter }) => {
  return (
    <div className="types-filter-chips">
      {filterList.map((filter, index) => (
        <CustomChip 
          key={`filter_${index}`}
          className="types-filter-chip"
          description={<FormattedMessage id={`preCog.typeFilters.${filter}`}/>}
          active={activeFilter === filter}
          onClick={() => {
            setActiveFilter(activeFilter === filter ? null : filter);
          }}
        />
      ))}
    </div>
  );
};
  
export default TypesFilters;